import React from 'react';
import { useHistory } from 'react-router-dom';
import CustomDialog from '../CustomDialog';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';

const SessionExpired = () => {
    const history = useHistory();

    return (
        <CustomDialog
            title={'Your session has expired due to inactivity'}
            alternative={'Please log in again.'}
            sx={{
                '& .MuiDialog-container': {
                    width: '500px'
                }
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    textAlign: 'center',
                }}
            >
                <Button
                    variant='contained'
                    onClick={() => {
                        history.push('/sign-in');
                    }}
                >
                    Login
                </Button>
            </Box>
        </CustomDialog>
    );
};

export default SessionExpired;
